import React, { Component } from 'react';

import TextSearch from 'app/components/common/TextSearch';

export default class SearchForm extends Component {
  render() {
    return (
      <form
        action="/search"
        className="header-search-form"
        role="search"
        method="get"
        autoComplete="off"
      >
        <TextSearch focusOnMount={false} mode="header" name="query" />
      </form>
    );
  }
}
